// General DCC hosted-web bootstrap consumer.
//
// Completes the already-designed VISINVOKE handoff on the portal side. When the installed DCC opens
// an AUTHORISED hosted-web product in its own dedicated WebviewWindow, it navigates to
//   https://app.visinvoke.com/<route>?dcc=<single-use-bootstrap>
// where <single-use-bootstrap> was minted by /v1/desktop/launch-authorization only after the DCC's
// desktop-session entitlement + account-restriction checks passed. This module exchanges that
// single-use token for the NORMAL VISINVOKE HttpOnly web session cookie via the backend consume
// endpoint, then strips the token from the visible URL/history so it is never retained.
//
// It is GENERAL, not Combat PRO-specific: any hosted-web product opened with ?dcc= is handled the
// same way. It is FAIL-CLOSED: on any error the token is still stripped and normal authentication
// proceeds (the api.js interceptor performs the 401 -> /login redirect for a truly unauthenticated
// visit). The JWT is never exposed to JavaScript: the backend sets it as the HttpOnly cookie and this
// code only ever sees {ok:true}. No localStorage auth, no bt_auth_token.
import API from './api';

function stripDccParam() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('dcc')) return;
    params.delete('dcc');
    const qs = params.toString();
    const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState(window.history.state, document.title, newUrl);
  } catch (e) {
    // ignore — stripping is best-effort cosmetics; the token is single-use regardless.
  }
}

export async function consumeDccBootstrapIfPresent() {
  let token = null;
  try {
    token = new URLSearchParams(window.location.search).get('dcc');
  } catch (e) {
    return false;
  }
  if (!token) return false;

  let ok = false;
  try {
    // withCredentials is set globally on API, so the Set-Cookie for .visinvoke.com is stored by the
    // WebView2 cookie jar and sent on every subsequent same-domain request.
    await API.post('/v1/desktop/web-session/consume', { bootstrap: token });
    ok = true;
  } catch (e) {
    ok = false; // fail closed: normal auth (interceptor) takes over
  }
  // ALWAYS remove the single-use token from the visible route/history, whatever the outcome.
  stripDccParam();
  return ok;
}
